import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';

import urls from 'constants/urls';
import ViewGeneralActions from 'components/common/ViewGeneralActions';
import { PurchaseRequestStatus } from 'hooks/api/usePurchaseRequest';
import pencilSvg from 'assets/img/newPencil.svg';
import twoRoundArrowSvg from 'assets/img/twoRoundArrow.svg';
import rejectSvg from 'assets/img/closeRevenue.svg';

type PropsT = {
  id: string;
  status: PurchaseRequestStatus;
  changeStatusToNew: () => void;
  onReject: () => void;
};

const ActionsButton: FC<PropsT> = ({ id, status, changeStatusToNew, onReject }) => {
  const history = useHistory();

  const getButtonsList = () => {
    switch (status) {
      case PurchaseRequestStatus.NEW:
        return [
          {
            image: pencilSvg,
            title: 'forms.purchaseRequest.editRequest',
            style: { color: '#838998' },
            onClick: () => history.push(`${urls.getPurchaseRequestList()}/edit/${id}`),
          },
          {
            image: rejectSvg,
            title: 'forms.purchaseRequest.reject',
            style: { color: '#838998', alignItems: 'center' },
            imageStyle: { width: 12, height: 12 },
            onClick: onReject,
          },
        ];
      case PurchaseRequestStatus.FUNDED:
        return [
          {
            image: rejectSvg,
            title: 'forms.purchaseRequest.reject',
            style: { color: '#838998', alignItems: 'center' },
            imageStyle: { width: 12, height: 12 },
            onClick: onReject,
          },
        ];
      case PurchaseRequestStatus.REPAID:
      case PurchaseRequestStatus.PENDING:
      case PurchaseRequestStatus.SIGNED:
        return [
          {
            image: twoRoundArrowSvg,
            title: 'forms.purchaseRequest.resetToNew',
            style: { color: '#838998' },
            onClick: changeStatusToNew,
          },
        ];
      case PurchaseRequestStatus.REJECTED:
        return [];
      default:
        return [];
    }
  };

  return (
    <div>
      <ViewGeneralActions
        buttonList={getButtonsList()}
        menuStyle={
          status === PurchaseRequestStatus.NEW
            ? { width: 144, height: 84, padding: 4, display: 'flex', flexDirection: 'column', gap: 4 }
            : undefined
        }
      />
    </div>
  );
};

export default ActionsButton;
